var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMortarboardinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1098_2340)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.4141 22.4332L29.0381 20.8092L30.6622 22.4332L29.0381 24.0573L27.4141 22.4332Z",
  fill: "#07BEB8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.0432 26.6311C28.6815 26.6692 28.2344 26.3085 27.9766 26.0063V28.3726C27.9766 28.9617 28.4541 29.4393 29.0432 29.4393C29.6323 29.4393 30.1098 28.9617 30.1098 28.3726V26.0063C29.8432 26.2975 29.505 26.6337 29.0432 26.6311Z",
  fill: "#07BEB8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.6833 2.57116L1.44995 7.3637C1.29593 7.41949 1.29513 7.63705 1.44875 7.69399L14.4592 12.5136C14.4982 12.528 14.541 12.5283 14.58 12.5142L27.9925 7.67862C28.1474 7.62277 28.1475 7.40384 27.9928 7.34781L14.8031 2.57116C14.7644 2.55717 14.722 2.55717 14.6833 2.57116Z",
  fill: "#07BEB8"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M14.8763 14.6752C14.7595 14.7173 14.637 14.7384 14.5146 14.7384C14.3891 14.7384 14.2636 14.7162 14.1441 14.6719L4.81055 11.2144V17.6143C4.81055 17.7775 4.87242 17.9343 4.98441 18.053C5.61644 18.7229 8.10104 20.8111 14.5146 20.8111C20.9253 20.8111 23.4777 18.725 24.1326 18.0542C24.2493 17.9347 24.314 17.7746 24.314 17.6077V11.2727L14.8763 14.6752Z",
  fill: "#07BEB8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.9766 9.95225V18.8572C28.707 17.9505 29.4964 18.1201 30.1099 18.8572V9.18317L27.9766 9.95225Z",
  fill: "#07BEB8"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1098_2340"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29.3333,
  height: 29.3333,
  fill: "white",
  transform: "translate(1.33398 1.33331)"
})))));

export default SvgMortarboardinline;